import _ from 'lodash'
export default class {
  constructor(){
    this.pathsapp = require.context("@", true, /\.vue|js|json$/, 'lazy').keys();
    this.pathsnoext =  this.pathsapp.filter(v=>!v.endsWith(".json")).map(v=>v.replace(/\.vue/g, '').replace(/\.js/g, ''));

    let packs = [];
    packs = _.union(packs, this.pathsapp.filter(v=>v.startsWith('./packs/')).map(v=>v.split('/')[2]));
    this.packs = packs;

    this.pathlist = _.union([''], this.packs, ['framework'])

    this.componentes_client = _.uniq(this.pathsnoext.filter(v=>v.indexOf('/lib/componente/')!=-1).map(v=>v.split('/lib/componente/')[1]))
    this.componentesmr_client = _.uniq(this.pathsnoext.filter(v=>v.indexOf('/lib/componentemr/')!=-1).map(v=>v.split('/lib/componentemr/')[1]))
    this.tpl_client = _.uniq(this.pathsnoext.filter(v=>v.indexOf('/admin/tpl/')!=-1).map(v=>v.split('/admin/tpl/')[1]))
    this.tpluser_client = _.uniq(this.pathsnoext.filter(v=>v.indexOf('/lib/tpl/')!=-1).map(v=>v.split('/lib/tpl/')[1]))
    this.filtro_client = _.uniq(this.pathsnoext.filter(v=>v.indexOf('/lib/filtro/')!=-1).map(v=>v.split('/lib/filtro/')[1]))
    this.libauto_client = _.uniq(this.pathsnoext.filter(v=>v.indexOf('/lib/auto/')!=-1).map(v=>v.split('/lib/auto/')[1]))
    this.pageroutes =  _.uniq(this.pathsnoext.filter(v=>v.indexOf('/page/')!=-1).map(v=>"/"+v.split('/page/')[1]))
    
    //console.log(this.pathsapp,this.pathsnoext )
  }

  // requiremix(path, nodef=false){
  //   for(let p of this.pathlist){
  //     let w = path.replace('@/', './'+(p==''?'':(p+'/')))
  //     if(this.pathsapp.indexOf(w)!==-1 || this.pathsnoext.indexOf(w)!==-1 ){
  //         //console.log('did', '@/'+w.substr(2))
        
  //         //return eval(`require('${"@/" + w.substr(2)}').default;`);
        
  //         if(nodef==true)
  //           return require('@/'+w.substr(2)); 
  //         return require('@/'+w.substr(2)).default; 
  //     }
  //   }
  // }

  requirecmpmix(path){
    for(let p of this.pathlist){
      let w = path.replace('@/', './'+(p==''?'':(p+'/')))
      if(this.pathsapp.indexOf(w)!==-1 || this.pathsnoext.indexOf(w)!==-1 ){
          //console.log('did', '@/'+w.substr(2))

          return ()=>import('@/'+w.substr(2)); 
      }
    }
  }
  

  /*
  importmix(path){
    for(let p of this.pathlist){
      let w = path.replace('@/', './'+(p==''?'':(p+'/')))
      if(this.pathsapp.indexOf(w)!==-1 || this.pathsnoext.indexOf(w)!==-1 ){
        console.log('did0', '@/'+w)
        console.log('did', '@/'+w.substr(2))
        return import('@/'+w.substr(2)); 
      }
    }
  }*/
  
}
